import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import '../../../../styles/detailStyles.css';
import PCLayout from '../../PCLayout';

const ResearchDetailPage = ({ isDarkMode, toggleTheme }) => {
    const navigate = useNavigate();
    const [researchData, setResearchData] = useState([]);
    const [selectedResearch, setSelectedResearch] = useState(null);

    useEffect(() => {
        fetch('/data/research.json')
            .then(response => response.json())
            .then(data => setResearchData(data))
            .catch(error => console.error('Error fetching research data:', error));
    }, []);

    // Handle card click
    const handleCardClick = (research) => {
        setSelectedResearch(research);
    };

    // Handle modal close
    const handleCloseModal = () => {
        setSelectedResearch(null);
    };

    useEffect(() => {
        const handleEscape = (e) => {
            if (e.key === 'Escape') {
                handleCloseModal();
            }
        };

        if (selectedResearch) {
            document.addEventListener('keydown', handleEscape);
        }

        return () => {
            document.removeEventListener('keydown', handleEscape);
        };
    }, [selectedResearch]);

    const handleBack = () => {
        navigate('/prof', { state: { targetSection: 'research' } });
    };

    return (
        <PCLayout
            isDarkMode={isDarkMode}
            toggleTheme={toggleTheme}
            activePage="research"
        >

            <div className="detailPageContent">
                <div className="inlineBackButtonContainer">
                    <button onClick={handleBack} className="inlineBackButton">
                        <i className="fa-solid fa-arrow-left"></i> Back
                    </button>
                </div>
                <div className="cardGrid">
                    {researchData.length > 0 ? (
                        researchData.map((research) => (
                            <div
                                className="card researchCard"
                                key={research.id}
                                onClick={() => handleCardClick(research)}
                            >
                                {research.image && (
                                    <div className="cardImage">
                                        <img src={research.image} alt={research.title} />
                                        <div className="cardIconOverlay">
                                            {research.pdfFileName && (
                                                <a
                                                    href={`/researchPapers/${research.pdfFileName}`}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className="cardIconBtn cardIconPdf"
                                                    onClick={(e) => e.stopPropagation()}
                                                    title="Download PDF"
                                                >
                                                    <i className="fa-solid fa-file-pdf"></i>
                                                </a>
                                            )}
                                            {research.url && (
                                                <a
                                                    href={research.url}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className="cardIconBtn cardIconLink"
                                                    onClick={(e) => e.stopPropagation()}
                                                    title="View Published"
                                                >
                                                    <i className="fa-solid fa-arrow-up-right-from-square"></i>
                                                </a>
                                            )}
                                        </div>
                                    </div>
                                )}

                                <h3 className="cardTitle">{research.title}</h3>

                                <p className="cardDate">{research.acceptedAt}</p>

                                <p className="cardDescription">
                                    {research.summary}
                                </p>
                            </div>
                        ))
                    ) : (
                        <p>Loading research...</p>
                    )}
                </div>
            </div>

            {selectedResearch && (
                <div className="modalOverlay" onClick={handleCloseModal}>
                    <div className="projectModal researchModal" onClick={(e) => e.stopPropagation()}>
                        <button className="modalClose" onClick={handleCloseModal}>
                            <i className="fa-solid fa-times"></i>
                        </button>

                        {selectedResearch.image && (
                            <div className="modalImage researchModalImage">
                                <img src={selectedResearch.image} alt={selectedResearch.title} />
                            </div>
                        )}

                        <h2 className="modalTitle">{selectedResearch.title}</h2>

                        <p className="modalAccept">
                            Accepted at <strong>{selectedResearch.acceptedAt}</strong>
                        </p>



                        <div className="modalAbstractSection">
                            <h3>Abstract</h3>
                            <p className="modalDescription">
                                {selectedResearch.abstract}
                            </p>
                        </div>

                        {selectedResearch.keyResults && (
                            <div className="modalBulletsSection">
                                <h3>Key Results & Findings</h3>
                                <ul className="modalBullets">
                                    {selectedResearch.keyResults.map((result, index) => (
                                        <li key={index}>{result}</li>
                                    ))}
                                </ul>
                            </div>
                        )}

                        {selectedResearch.conclusion && (
                            <div className="modalConclusionSection">
                                <h3>Conclusion</h3>
                                <p className="modalDescription">
                                    {selectedResearch.conclusion}
                                </p>
                            </div>
                        )}

                        <div className="modalLinks">
                            {selectedResearch.url && (
                                <a
                                    href={selectedResearch.url}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="modalLink"
                                >
                                    <i className="fa-solid fa-arrow-up-right-from-square"></i> View Publication
                                </a>
                            )}
                            {selectedResearch.pdfFileName && (
                                <a
                                    href={`/researchPapers/${selectedResearch.pdfFileName}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="modalLink"
                                >
                                    <i className="fa-solid fa-file-pdf"></i> PDF
                                </a>
                            )}
                        </div>
                    </div>
                </div>
            )}
        </PCLayout>
    );
};

export default ResearchDetailPage;
